<template>
    <div id="app">
        <router-view />
        <ext-slot name="app.global" />
        <app-toast />
    </div>
</template>

<script>
import { getLookup, getMerchantInfo, getMemberInfo } from '@/core/http/api';
import { syncTemplate } from '@/core/template-engine';
import { syncLoginState } from '@/core/state';

export default {
    name: 'App',
    created() {
        this.fetchSystemConfig();
        if (localStorage.getItem('gamingToken')) {
            this.fetchMemberInfo();
        } else {
            this.fetchMerchantInfo();
        }
        this.$root.$on('fetch-member-info', this.fetchMemberInfo);
        this.$root.$on('login-state-changed', syncLoginState);
    },
    beforeDestroy() {
        this.$root.$off('fetch-member-info', this.fetchMemberInfo);
        this.$root.$off('login-state-changed', syncLoginState);
    },
    methods: {
        async fetchSystemConfig() {
            try {
                const res = await getLookup();
                const settings = res.data?.data?.system ?? res.data?.data ?? res.data ?? {};
                this.$sharedState.systemCurrency = settings.SYSTEM_CURRENCY || '';
            } catch {
                // silent
            }
        },
        async fetchMemberInfo() {
            try {
                const res = await getMemberInfo();
                if (res.data?.error_code === '0') {
                    const data = res.data.data;
                    this.$sharedState.memberInfo = data;
                    syncTemplate(data?.merchant_info?.template);
                }
            } catch {
                // token expired or invalid
            }
        },
        async fetchMerchantInfo() {
            try {
                const res = await getMerchantInfo();
                if (res.data?.error_code === '0') {
                    syncTemplate(res.data?.data?.merchant?.template);
                }
            } catch {
                // silent
            }
        }
    }
};
</script>
